import React from 'react';
import ReactDom from 'react-dom';

import MainView from './react/mainView.jsx';
import SearchView from './react/searchView.jsx';
import CustomView from './react/customView.jsx';
import LobbyView from './react/lobbyView.jsx';
import LeaderView from './react/leaderView.jsx';
import TutorialView from './react/tutorialView.jsx';
import ReplayView from './react/replayView.jsx';
import EndView from './react/endView.jsx';
import RankedBeginView from './react/rankedBeginView.jsx';
import TutorialOverlayView from './react/tutorialOverlayView.jsx';
import JoinCustomView from './react/joinCustomView.jsx';
import StartBotGame from './react/startBotGame.jsx';
import DeadView from './react/deadView.jsx';
import CookieView from './react/cookieView.jsx';
const { hasDoneCookieInit, setAllowCookies } = require('./cookieUtils');

import { FaExclamationCircle } from 'react-icons/fa';
const config = require('../config');

var reactRender = { isDisconnected: false };
reactRender.MAX_WIDTH = 700;
reactRender.MAX_HEIGHT = 550;


var shouldShowRedirect = true;
window.addEventListener("message", function(event) {
  shouldShowRedirect = false;
}, false);

let messageText = ""
let lastComponent = [];
let componentHiddenByCookieView = null;
let animationColor = "255, 0, 0";
let isRendering = false;
let needsToShowCookieSettings = false;
let lastCallback = null;

function clickPrivacySettings() {
	needsToShowCookieSettings = true;
	doRender(lastComponent, lastCallback);
}

function doRender(component, callback) {

	animationColor = "255, 0, 0";
	if ( window.location !== window.parent.location ) {

		document.body.style.paddingLeft = 0;
		document.body.style.paddingTop = 0;
		reactRender.MAX_WIDTH = window.innerWidth;
		reactRender.MAX_HEIGHT = window.innerHeight;
	} else {

		document.body.style.paddingLeft = "6px";
		document.body.style.paddingTop = "6px";
		reactRender.MAX_WIDTH = 700;
		reactRender.MAX_HEIGHT = 550;
	}

	lastCallback = callback;
	lastComponent = component;
	componentHiddenByCookieView = component;

	let cookieComponent = <div/>;
	if (!hasDoneCookieInit() || needsToShowCookieSettings) {
		const clickYes = function() {
			setAllowCookies(true);

			console.log("callBack:", callback);
			if (callback)
				callback();
			else
				doRender(component);
		}
		const clickNo = function() {
			setAllowCookies(false);

			if (callback)
				callback();
			else
				doRender(component);
		}
		const clickCustom = function() {
			setAllowCookies(false);
			
			if (callback)
				callback();
			else
				doRender(component);
		}
		cookieComponent = <CookieView clickYes={clickYes} clickNo={clickNo} clickCustom={clickCustom}/>;
		needsToShowCookieSettings = false;
	}

	const divStyle = {
	  maxWidth: reactRender.MAX_WIDTH,
	  maxHeight: reactRender.MAX_HEIGHT,
	};

	ReactDom.render((
		<div class="sizer" style={divStyle}>
			{ component }
			{ renderMessageText() }
			{ cookieComponent }
		</div>
	), document.getElementById('react-app'));

	if (!isRendering) {
		isRendering = true;
		requestAnimationFrame(drawGrid);
	}
}

function renderMessageText() {
	if (messageText.length > 0)
	{
		return (
			<div class="overMessage">
		        <FaExclamationCircle/> {messageText}
	        </div>
		);
	}
}

reactRender.animation = function() {
	edgeAlpha = 1;
	glowAlpha = 1;
	addGameObj(new ReactRing());
}

reactRender.showAlert = function(main, dontHide) {

	messageText = main;
	doRender(lastComponent, lastCallback);
	if (main.length > 0 && !dontHide)
		setTimeout(() => reactRender.showAlert(""), 3500);
}	

var animationSpeed = 1;
reactRender.main = function(name, canEditName, clickFind, clickCustom, clickBottomRight, clickTutorial, bottomRightMessage, clickLeaders, clickFindRanked) {

	gameObjects.length = 0;
	edgeAlpha = 1;
	animationSpeed = 1;
	const callBack = () => { reactRender.main(name, canEditName, clickFind, clickCustom, clickBottomRight, clickTutorial, bottomRightMessage, clickLeaders, clickFindRanked); };
	doRender(<MainView clickPrivacySettings={clickPrivacySettings} shouldShowRedirect={shouldShowRedirect} defaultName={name} canEditName={canEditName} clickFind={clickFind} clickCustom={clickCustom} clickBottomRight={clickBottomRight} 
		clickTutorial={clickTutorial} bottomRightMessage={bottomRightMessage} clickLeaders={clickLeaders} clickFindRanked={clickFindRanked}/>, callBack);
}

reactRender.joinCustom = function(clickJoin, defaultName, clickBack) {

	gameObjects.length = 0;
	edgeAlpha = 1;
	animationSpeed = 1;
	doRender(<JoinCustomView clickPrivacySettings={clickPrivacySettings} clickJoin={clickJoin} defaultName={defaultName} clickBack={clickBack}/>);
}

reactRender.tutorialOverlay = function(clickX) {
	doRender(<TutorialOverlayView clickX={clickX}/>);
}


reactRender.lobby = function(clickBack, roomName, joinCode, players, isAdmin, clickStart, clickKick, addBot, setBotLevel, numBots, botLevel, 
	settingsOverlayOpen, clickSettings, customGameSettings, reRender, resetToDefault) {

	animationSpeed = 0;
	console.log("customGameSettings", customGameSettings);
	doRender(<LobbyView clickBack={clickBack} roomName={roomName} joinCode={joinCode} players={players} isAdmin={isAdmin} 
		clickStart={clickStart} clickKick={clickKick} baseURL={config.BACKEND_URL} addBot={addBot} setBotLevel={setBotLevel}
		numBots={numBots} botLevel={botLevel} settingsOverlayOpen={settingsOverlayOpen} clickSettings={clickSettings} customGameSettings={customGameSettings}
		reRender={reRender} resetToDefault={resetToDefault}/>);
} 

reactRender.search = function(clickBack, searchMessage, startAiGame, clickBottomRight, bottomRightMessage, ranked, clickRankedBot) {

	animationSpeed = 8;
	doRender(<SearchView clickBack={clickBack} searchMessage={searchMessage} startAiGame={startAiGame} 
		bottomRightMessage={bottomRightMessage} clickBottomRight={clickBottomRight} ranked={ranked} firstTimeRanked={true} clickRankedBot={clickRankedBot}/>);
	if (ranked)
		animationColor = "0, 0, 255";
}

reactRender.startBotGame = function(clickBack, clickStart) {

	animationSpeed = 1;
	doRender(<StartBotGame clickBack={clickBack} clickStart={clickStart}/>);
}

reactRender.custom = function(clickBack, clickCreate, clickJoin) {

	doRender(<CustomView clickBack={clickBack} clickCreate={clickCreate} clickJoin={clickJoin}/>);
}

reactRender.leader = function(clickBack, clickPage, pageData, myRank, rankData ) {

	doRender(<LeaderView clickBack={clickBack} clickPage={clickPage} pageData={pageData} myRank={myRank} rankData={rankData}/>);
}	

reactRender.replay = function(playAmt, isPaused, clickPlay, clickScrubber, returnToMainMenu, shareLink, backButtonText) {

	doRender(<ReplayView playAmt={playAmt} isPaused={isPaused} clickPlay={clickPlay} clickScrubber={clickScrubber} 
		returnToMainMenu={returnToMainMenu} shareLink={shareLink} backButtonText={backButtonText} maxWidth={reactRender.MAX_WIDTH} baseURL={config.BACKEND_URL}/>);
}	

reactRender.tutorial = function(clickYes, clickNo) {

	doRender(<TutorialView clickPrivacySettings={clickPrivacySettings} clickYes={clickYes} clickNo={clickNo}/>);
}	

reactRender.end = function(ending, findGameText, clickFindGame, clickMainMenu, clickShare, rank, rankDelta, score, scoreDelta, replayReady, rankedGame, rankedGameInBackground) {

	doRender(<EndView ending={ending} findGameText={findGameText} clickFindGame={clickFindGame} clickShare={clickShare} clickMainMenu={clickMainMenu} 
		rank={rank} rankDelta={rankDelta} score={score} scoreDelta={scoreDelta} replayReady={replayReady} rankedGame={rankedGame} rankedGameInBackground={rankedGameInBackground}/>);
}	

reactRender.dead = function(joinLinkText) {

	doRender(<DeadView joinLinkText={joinLinkText}/>);
}	

reactRender.rankedBegin = function(opacity, name1, name2, rank1, rank2) {

	doRender(<RankedBeginView opacity={opacity} name1={name1} name2={name2} rank1={rank1} rank2={rank2}/>);
}	

reactRender.nothing = function() {

	ReactDom.render((<span/>), document.getElementById('react-app'));
}

const gameObjects = [];
const squareList = [];
var edgeAlpha = 1;
var glowAlpha = 1;
var timeNow = new Date().getTime();
var startTime = timeNow;


function addGameObj(newObj) {
  newObj.kill = function() {this.toKill = true;};
  gameObjects.unshift(newObj);
}

function removeFromArray(obj, ary) {

  var index = ary.indexOf(obj);
  if (index > -1)
    ary.splice(index, 1);
}

var ctx;
function drawGrid() {

	var canvas = document.getElementById("backCanvas");
	if (!canvas)
	{	
		animationSpeed = 1;
		edgeAlpha = 1;
		glowAlpha = 0;
		gameObjects.length = 0;
		isRendering = false;
		return;
	}

	var lastTime = timeNow;
	timeNow = new Date().getTime();
	var dTime = timeNow - lastTime;
	if (dTime > 60)
		dTime = 60;
	if (timeNow < startTime + 500)
		dTime = 0;

	ctx = canvas.getContext("2d");

	ctx.canvas.width  = Math.min(window.innerWidth, reactRender.MAX_WIDTH);
	ctx.canvas.height = Math.min(window.innerHeight, reactRender.MAX_HEIGHT);

	ctx.clearRect(0, 0, canvas.width, canvas.height);
	ctx.fillStyle = "rgb(255, 0, 0)";

	if (gameObjects.length == 0) {

		var w = ctx.canvas.width;
		var h = ctx.canvas.height

		if (squareList.length == 0) {
			for (var i = 0; i < 50; i++) {

			  var square = { };
			  square.size = Math.random() * 100 + 100;
			  square.x = Math.random() * w - square.size / 2;
			  square.y = Math.random() * h - square.size / 2;
			  square.alpha = Math.random() * Math.abs(w / 2 - square.x) / w * 2 * Math.abs(h / 2 - square.y) / h * 2;
			  if (square.alpha > 0.25)
			    squareList.push(square);
			}
		}

		var s = 64;
		var alpha = 1.5;

		for (var x = 0; x < w; x += s)
		{
			for (var y = 0; y < w; y += s)
			{
				var x2 = x;
				var y2 = y;
				addGameObj(new ReactBox(x2 + s * 0.05, y2+ s * 0.05, s * 0.9, s * 0.9, alpha + Math.random()));
				alpha += 0.05;
			}
		}

		for (var i = 0; i < 30; i++) {
			addGameObj(new ReactBit(w / 2, h / 2, animationColor));
		}
		
		addGameObj(new ReactRing());
	}

	if (animationSpeed > 0) {

		for (var i = 0; i < gameObjects.length; i++) {
		  var obj = gameObjects[i];
		  if (!obj.toKill)
		    obj.update(dTime, ctx);
		}

		for (var i = 0; i < gameObjects.length; i++) {
		  var obj = gameObjects[i];
		  if (obj.toKill)
		    removeFromArray(obj, gameObjects);
		}
	}


	edgeAlpha -= dTime * 0.001;
	glowAlpha -= dTime * 0.001;
	if (glowAlpha < 0)
		glowAlpha = 0;
	
	if (edgeAlpha > 0) {
		ctx.globalAlpha = edgeAlpha * 0.1;

		ctx.fillStyle = "rgb(" + animationColor + ")";
		ctx.fillRect(0, 0, 10, canvas.height);
		ctx.fillRect(canvas.width - 10, 0, 10, canvas.height);
	}

	var main = "black"
	var stroke = "black"

	ctx.strokeStyle = stroke;
	ctx.globalAlpha = 0.05;
	ctx.fillStyle = main;

	for (var i = 0; i < squareList.length; i++) {
	  var square = squareList[i];
	  ctx.globalAlpha = square.alpha * 0.015;
	  ctx.lineWidth = 4;
	  ctx.beginPath();
	  ctx.rect(square.x, square.y, square.size, square.size);
	  ctx.stroke();

	  ctx.globalAlpha = square.alpha * 0.15;
	  ctx.lineWidth = 1;
	  ctx.stroke();
	}

	requestAnimationFrame(drawGrid);
}

function ReactBox(x, y, w, h, a, drawOutline) {
  this.alpha = a;

  this.x = x;
  this.y = y;
  this.w = w;
  this.h = h;
  this.drawOutline = drawOutline;
  this.preserve = true;
  this.alphaChange = 0.005;
}                 

ReactBox.prototype.update = function(dTime, ctx) {

  this.alpha -= dTime * this.alphaChange * animationSpeed;
  if (this.alpha <= 0)
  {
	this.alphaChange = 0.00015;
  	if (Math.random() > 1 - 0.00075 * animationSpeed) {
  		if (animationSpeed < 1.5 || Math.random() > 0.5) {
  			var b = new ReactBit(this.x, this.y, animationColor);
	  		addGameObj(b);
	  		//b.downAlways = true;

	  		if (Math.random() > 0.5 || animationSpeed > 1.5) {
		  		var w = ctx.canvas.width;
		  		var h = ctx.canvas.height;
		  		if (false && Math.abs(this.x - w / 2) > Math.abs(this.y - h / 2)) {
		  			if (this.x < w / 2)
		  				b.startMove = 2;
		  			else
		  				b.startMove = 0;
		  		} else {
		  			if (this.y < h / 2)
		  				b.startMove = 3;
		  			else
		  				b.startMove = 1;
		  		}
		  		b.move = b.startMove;
		  	}
	  	}
	  	this.alpha = 3 * Math.random();
	}
  }
  else
  { 

    var alpha = this.alpha * (1 + glowAlpha);

    ctx.lineWidth = 1;
	ctx.strokeStyle = "rgb(" + animationColor + ")";
    ctx.fillStyle = "rgb(" + animationColor + ")";
    ctx.globalAlpha = alpha * 0.0125;

    ctx.fillRect(this.x, this.y, this.w, this.h);

	ctx.globalAlpha = alpha * 0.125;
    ctx.beginPath();
	ctx.rect(this.x, this.y, this.w, this.h);
	ctx.stroke();

	ctx.globalAlpha = this.alpha * 0.05;
    ctx.font = "16px Arial";
	ctx.textAlign = "left";

	if (animationSpeed > 1) {

	    ctx.fillText(Math.floor(Math.random() * 10), this.x + this.w * 0.1, this.y + this.h * 0.3);
	}
  }
}

function ReactRing() {
	this.alpha = 1.0;
}                 

ReactRing.prototype.update = function(dTime, ctx) {

  this.alpha -= dTime * 0.001 * animationSpeed / 8;
  if (this.alpha <= 0)
  {
  	if (animationSpeed < 2) {
	  	this.alpha = 1;

	  	for (var i = 0; i < 30; i++) {
	  		addGameObj(new ReactBit(ctx.canvas.width / 2, ctx.canvas.height / 2, animationColor));
	  	}
    } else {
    	kill(this);
    }
  }
  else
  { 
    ctx.beginPath();
    ctx.lineWidth = 4;
    ctx.globalAlpha = this.alpha * 0.5;
	ctx.strokeStyle = "rgb(" + animationColor + ")";
    ctx.arc(ctx.canvas.width / 2, ctx.canvas.height / 2, (1 - this.alpha) * (ctx.canvas.width + ctx.canvas.height) / 2, 0, Math.PI * 2)
    ctx.lineWidth = 1;
	ctx.stroke();
	ctx.lineWidth = 5;
	ctx.globalAlpha = this.alpha * 0.03;
	ctx.stroke();
	ctx.lineWidth = 1;
  }
}

function ReactBit(x, y, color, alpha = 1) {
  this.alpha = alpha;
  this.x = x;
  this.y = y;
  this.color = color;
  this.startMove = Math.floor(Math.random() * 4);
  this.move = this.startMove;
  this.timer = 0;
  this.moveMult = Math.random();
  this.px = x;
  this.py = y;
}

ReactBit.prototype.update = function (dTime, ctx) {
  
  this.alpha -= dTime * 0.00025;
  if (this.alpha <= 0)
    kill(this);
  else {

    this.timer += dTime;

    if (this.timer > 200) {
      var pMove = this.move;

      this.timer -= 400 * Math.random();
      this.move = this.startMove;
      var change = 0.66;
      if (this.downAlways)
      	change = 0.95;

      if (Math.random() > change) {
      	
        this.move += Math.random() > 0.5 ? 1 : -1;
        if (this.move > 3)
          this.move = 0;
        if (this.move < 0)
          this.move = 3;
      }

      if (this.move != pMove || true) {
        addGameObj(new Line(this.x, this.y, this.px, this.py, this.color, this.alpha, 0.0025));
        this.px = this.x;
        this.py = this.y;
      }
    }
    var moveAmt = dTime * 0.1;
    if (this.move == 0)
      this.x += moveAmt;
    else if (this.move == 1)
      this.y += moveAmt;
    else if (this.move == 2)
      this.x -= moveAmt;
    else if (this.move == 3)
      this.y -= moveAmt;

    ctx.globalAlpha = this.alpha * 0.325;
    ctx.strokeStyle = "rgb(" + this.color + ")";
    ctx.lineWidth = 1.0;
    ctx.beginPath();
    ctx.moveTo(this.px, this.py);
    ctx.lineTo(this.x, this.y);
    ctx.stroke();

    ctx.lineWidth = 8;
    ctx.globalAlpha = this.alpha * 0.02;
    ctx.stroke();
    ctx.lineWidth = 1;
  }
}

function kill(o) {
	o.kill();
}

function Line(x, y, x2, y2, color, alpha, alphaChange) {
  this.alpha = alpha;
  this.alphaChange = alphaChange;
  this.x = x;
  this.y = y;
  this.x2 = x2;
  this.y2 = y2;
  this.color = color;

}
Line.prototype.update = function (dTime, ctx) {

  this.alpha -= dTime * this.alphaChange;
  if (this.alpha <= 0)
    kill(this);
  else {

    ctx.globalAlpha = this.alpha * 0.5;
    ctx.strokeStyle = "rgb(" + this.color + ")";
    ctx.lineWidth = 1.0;
    ctx.beginPath();
    ctx.moveTo(this.x, this.y);
    ctx.lineTo(this.x2, this.y2);
    ctx.stroke();

    return;
    ctx.globalAlpha = this.alpha * 0.05;
    ctx.lineWidth = 10;
    ctx.stroke();
    ctx.lineWidth = 1;
  }
}
module.exports = { reactRender };